import CustomAsideInfo from './CustomAsideInfo';

export default CustomAsideInfo;
